import { getEnvironment as v } from "./lib/Environment.js";
import { sendAnalyticsEvent as w } from "./lib/Analytics.js";
import { generatePreviewImage as j } from "./lib/PreviewImageGenerator.js";
import { stubbableFetch as k } from "./lib/StubbableFetch.js";
import { getUserId as A, getAccessToken as L } from "./lib/IMSLib.js";
import { t as O } from "./toFinite-dLr2ngf2.js";
const C = { development: { AssetsUrl: "https://assets-stage.adobecc.com", LibrariesUrl: "http://localhost:8010/proxy", AssetsStorageUrl: "https://cc-api-storage-stage.adobe.io", CollaborationUrl: "https://cc-collab-stage.adobe.io", LinkUrl: "https://links-stage.adobe.io", ReportAbuseUrl: "https://leia-stage.adobe.io/v1/acp_report_abuse" }, test: { AssetsUrl: "https://assets-stage.adobecc.com", LibrariesUrl: "http://localhost:8010/proxy", AssetsStorageUrl: "https://cc-api-storage-stage.adobe.io", CollaborationUrl: "https://cc-collab-stage.adobe.io", LinkUrl: "https://links-stage.adobe.io", ReportAbuseUrl: "https://leia-stage.adobe.io/v1/acp_report_abuse" }, staging: { AssetsUrl: "https://assets-stage.adobecc.com", LibrariesUrl: "https://platform-cs-edge-stage.adobe.io", AssetsStorageUrl: "https://cc-api-storage-stage.adobe.io", CollaborationUrl: "https://cc-collab-stage.adobe.io", LinkUrl: "https://links-stage.adobe.io", ReportAbuseUrl: "https://leia-stage.adobe.io/v1/acp_report_abuse" }, production: { AssetsUrl: "https://assets.adobe.com", LibrariesUrl: "https://platform-cs-edge.adobe.io", AssetsStorageUrl: "https://cc-api-storage.adobe.io", CollaborationUrl: "https://cc-collab.adobe.io", LinkUrl: "https://links.adobe.io", ReportAbuseUrl: "https://leia.adobe.io/v1/acp_report_abuse" } }, P = { APIKey: "TypeKit2" };
function i() {
  return Object.assign(P, C[v()]);
}
function E(e, t, a) {
  var n = -1, r = e.length;
  t < 0 && (t = -t > r ? 0 : r + t), (a = a > r ? r : a) < 0 && (a += r), r = t > a ? 0 : a - t >>> 0, t >>>= 0;
  for (var s = Array(r); ++n < r; ) s[n] = e[n + t];
  return s;
}
var N = Math.ceil, I = Math.max;
function _(e, t, a) {
  t = t === void 0 ? 1 : I(function(p) {
    var o = O(p), d = o % 1;
    return o == o ? d ? o - d : o : 0;
  }(t), 0);
  var n = e == null ? 0 : e.length;
  if (!n || t < 1) return [];
  for (var r = 0, s = 0, l = Array(N(n / t)); r < n; ) l[s++] = E(e, r, r += t);
  return l;
}
var m = ((e) => (e.Private = "private", e.Incoming = "incoming", e.Public = "public", e.Team = "team", e.Other = "other", e.All = "all", e))(m || {});
const Q = { CCSTORAGE: "2200", QUOTA: "40301" }, U = { noop: !0 };
function x(e) {
  const t = e.map(async (a) => {
    if (!(window.Typekit && a.cssName && a.webId && a.webFontStyle && a.webFontWeight)) return [a.postScriptName, null];
    const n = await j(a.cssName, a.webId, a.webFontStyle, a.webFontWeight, a.previewText);
    return [a.postScriptName, n];
  });
  return Promise.all(t).then((a) => Object.fromEntries(a));
}
function R() {
  const e = document.querySelector("meta[name=csrf-token]");
  return e ? { "X-CSRF-Token": e.getAttribute("content") } : {};
}
function F(e) {
  return (({ postScriptName: t, name: a, localizedName: n, family: r, localizedFamily: s, style: l, localizedStyle: p, typekitFontId: o, byofFontId: d, foundry: u, designer: b }) => ({ postScriptName: t, name: a, localizedName: n, family: r, localizedFamily: s, style: l, localizedStyle: p, typekitFontId: o, byofFontId: d, foundry: u, designer: b }))(e);
}
function z(e, t, a) {
  const n = [];
  if (n.push({ "font#data": F(e), id: window.crypto.randomUUID(), is_full_size: !1, is_external_link: !1, type: "application/vnd.adobe.font+json", relationship: "primary" }), a) {
    const r = Object.assign(a, { etag: window.crypto.randomUUID(), is_full_size: !1, is_external_link: !1, path: `${a.id}.jpg`, relationship: "rendition" });
    n.push(r);
  }
  return { client: J(t), representations: n, name: e.name, type: "application/vnd.adobe.element.font+dcx" };
}
function J(e) {
  return { app: i().APIKey, device: navigator.userAgent, deviceId: [i().APIKey, e].join("-") };
}
async function $(e) {
  return new Promise((t, a) => {
    if (!e.href || !e.retryAfter) return t(e);
    setTimeout(() => {
      const n = e.href.split("adobe.io")[1];
      c(`${i().LibrariesUrl}${n}`, { method: "GET", headers: { "Content-Type": "application/json" } }).then((r) => $(r).then(t)).catch(a);
    }, 1e3 * e.retryAfter);
  });
}
async function c(e, t = {}, a = !1) {
  const n = Object.assign(function(r = !1) {
    return { "X-Api-Key": i().APIKey, ...r ? {} : { Authorization: `Bearer ${L()}` } };
  }(a), t.headers || {});
  return t = Object.assign(t, { headers: n }), new Promise((r, s) => {
    k(e, t).then((l) => {
      l.text().then((p) => {
        let o = {};
        try {
          o = p.length > 0 ? JSON.parse(p) : {};
        } catch {
          o = {};
        }
        l.status >= 200 && l.status <= 399 ? (o.etag = l.headers.get("etag") || "", r(o)) : (o.requestId = l.headers.get("x-request-id") || "", o.status = l.status, o.endpoint = e, o.method = t.method, s(o));
      }).catch(s);
    }).catch(s);
  });
}
async function h(e, t = {}, a, n = []) {
  return c(e, t).then((r) => {
    var p;
    const s = r;
    s[a] = n.concat(s[a]);
    const l = (p = r._links) == null ? void 0 : p.next;
    if (l) {
      let o = new URL(e).pathname;
      const d = new URLSearchParams(o.split("?")[1]), u = new URLSearchParams(l.href.split("?")[1]), b = Object.assign(Object.fromEntries(d), Object.fromEntries(u));
      return o = o.split("?")[0] + "?" + new URLSearchParams(b).toString(), h(`${new URL(e).origin}${o}`, b, a, s[a]);
    }
    return r;
  });
}
async function V() {
  return c(`${i().LibrariesUrl}/api/v1/libraries/bookmarks`, { headers: { "Content-Type": "application/json" }, method: "GET" });
}
async function Y(e, t, a = !1) {
  let n, r;
  a && (n = await h(`${i().LibrariesUrl}/api/v1/libraries/${e}/elements?limit=300&selector=representations`, {}, "elements"), t = function(o, d) {
    const u = d.elements.map((b) => function(S) {
      var g;
      const y = S.representations;
      if (!y) return "";
      const f = (g = y.find((T) => T["font#data"])) == null ? void 0 : g["font#data"];
      return f ? f.postScriptName : "";
    }(b));
    return o.filter((b) => !u.includes(b.postScriptName || ""));
  }(t, n));
  var s;
  a && t.length === 0 ? (s = n, r = Promise.resolve(Object.assign(s, U))) : r = D(e, t);
  const l = await r;
  return l.noop ? U : l;
}
async function Z(e) {
  const t = Object.keys(e).length > 0 ? "?" + new URLSearchParams({ ...e }).toString() : "";
  return c(`https://${window.location.host}/libraries.json` + t, {});
}
async function ee(e) {
  return h(`${i().LibrariesUrl}/api/v1/search`, { body: JSON.stringify({ name: e }), headers: { "Content-Type": "application/json" }, method: "POST" }, "libraries");
}
async function te(e) {
  return c(`${i().LibrariesUrl}/api/v1/libraries`, { body: e, headers: { "Content-Type": "application/json" }, method: "POST" }).then((t) => $(t));
}
async function ae(e) {
  return c(`${i().LibrariesUrl}/api/v1/libraries/${e}`, { headers: { "Content-Type": "application/json" }, method: "DELETE" });
}
async function ne(e, t) {
  return c(`${i().LibrariesUrl}/api/v1/libraries/${e}/metadata`, { body: JSON.stringify(t), headers: { "Content-Type": "application/json" }, method: "PUT" });
}
async function re(e) {
  return h(`${i().LibrariesUrl}/api/v1/libraries/${e}/elements?limit=300`, {}, "elements");
}
async function D(e, t) {
  return Promise.all([A(), x(t)]).then(async ([a, n]) => {
    const r = await K(e, n), s = { requests: t.map((l) => (r[l.postScriptName] || w("library-thumbnail-error", { libraryId: e, postscriptName: l.postScriptName }), { body: z(l, a, r[l.postScriptName]), method: "POST", path: `/api/v1/libraries/${e}/elements` })) };
    return c(`${i().LibrariesUrl}/api/v1/libraries/${e}`, { body: JSON.stringify(s), headers: { "Content-Type": "application/json" }, method: "PATCH" });
  });
}
async function K(e, t) {
  return (await Promise.all(_(Object.entries(t), 28).map((a) => {
    const n = new FormData();
    return a.forEach(([r, s]) => {
      s && n.append(`file_${r}`, s, "thumbnail.jpg");
    }), n.entries().next().done ? Promise.resolve({}) : c(`https://${window.location.host}/libraries/${e}/representations`, { body: n, method: "POST", headers: R() });
  }))).reduce((a, n) => Object.assign(a, n), {});
}
async function se(e, t) {
  return c(`${i().LibrariesUrl}/api/v1/libraries/${e}/archive`, { body: JSON.stringify({ elementIds: t }), headers: { "Content-Type": "application/json" }, method: "POST" });
}
async function oe(e, t) {
  return c(`${i().LibrariesUrl}/api/v1/libraries/${e}/elements`, { body: JSON.stringify({ elements: t }), headers: { "Content-Type": "application/json" }, method: "DELETE" });
}
async function q(e) {
  return c(`${i().CollaborationUrl}/publinks/${e}`, { headers: { "Content-Type": "application/json" }, method: "GET" });
}
async function ie(e, t, a, n) {
  return c(`${i().CollaborationUrl}/publinks`, { body: JSON.stringify({ resource: `${i().AssetsStorageUrl}${t}`, metadata: { allowSubscribe: n, allowCopy: a }, description: e }), headers: { "Content-Type": "application/json" }, method: "POST" });
}
async function le(e) {
  return c(`${i().CollaborationUrl}/publinks/${e}`, { headers: { "Content-Type": "application/json" }, method: "GET" });
}
async function ce(e) {
  return c(`${i().LinkUrl}/api/v1/publinks/${e}`, { headers: { "Content-Type": "application/json", "If-Match": "*" }, method: "DELETE" });
}
async function pe(e, t, a, n) {
  return q(t).then((r) => {
    const s = r;
    return c(`${i().CollaborationUrl}/publinks/${t}/metadata`, { body: JSON.stringify({ allowSubscribe: n, allowCopy: a, description: e }), headers: { "Content-Type": "application/json", "If-Match": s.etag }, method: "PUT" });
  });
}
async function de(e) {
  return c(`${i().ReportAbuseUrl}`, { body: JSON.stringify(e), headers: { "Content-Type": "application/json" }, method: "POST" }, !0);
}
async function be(e) {
  return c(`${i().LinkUrl}/api/v1/bookmarks/${e}`, { headers: { "Content-Type": "application/json" }, method: "POST" });
}
async function ue(e) {
  return c(`${i().LinkUrl}/api/v1/bookmarks/${e}`, { headers: { "Content-Type": "application/json" }, method: "DELETE" });
}
const me = (e) => {
  var t;
  return ((t = e.details) == null ? void 0 : t.element_type_counts["application/vnd.adobe.element.font+dcx"]) || 0;
}, he = (e) => `/libraries/${e}`, ye = (e) => `${i().AssetsUrl}/libraries/${e}`, fe = () => new RegExp('^(?!\\s*$)(?!.*\\s$)(?!.*\\.$)[^\\\\/*?"|:<> ]*( [^\\\\/*?"|:<>]*)*[^\\\\/*?"|:<>.]$'), ge = (e) => {
  var t, a;
  return e.ownership === m.Incoming ? ((t = e.bookmark) == null ? void 0 : t.role) !== "editor" : e.ownership === m.Team ? !((a = e.assets_acl) != null && a["http://ns.adobe.com/adobecloud/rel/primary"]) || !e.assets_acl["http://ns.adobe.com/adobecloud/rel/primary"].includes("write") : e.ownership === m.Public;
};
export {
  m as L,
  Q as M,
  be as a,
  fe as b,
  Y as c,
  Z as d,
  i as e,
  te as f,
  ye as g,
  ae as h,
  ge as i,
  me as j,
  he as k,
  q as l,
  ie as m,
  le as n,
  ce as o,
  ne as p,
  de as q,
  ue as r,
  ee as s,
  oe as t,
  pe as u,
  se as v,
  V as w,
  re as x,
  D as y,
  K as z
};
//# sourceMappingURL=Libraries-B2pgogDz.js.map
